module.exports = __webpack_public_path__ + "img/66.2d340c44.jpg";